import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import { useMemoizedFn, useRequest } from 'ahooks';
import { useTranslate } from '@tolgee/react';
import { useExportFile } from 'components/ExportCenter/hooks/useExportCenter';
import { exportCancelOrderList, ProcessStatus } from 'services/api/refund';
import { getLocalTimeZone } from 'utils/timeZone';
import { FilterState } from '../hooks/useFilter';
import { useGetCancelListParams } from '../hooks/useCancelList';

interface CancelExportButtonProps {
  query: FilterState;
  statusFilter: ProcessStatus | 'ALL';
  platform: General.PlatformUpperCase;
}

export const CancelExportButton = (props: CancelExportButtonProps) => {
  const { query, statusFilter, platform } = props;
  const { t } = useTranslate();
  const getCancelListParams = useGetCancelListParams();
  const { run, loading: exportLoading } = useExportFile();

  const { runAsync: exportList } = useRequest(
    async () => {
      const data = await getCancelListParams(query, statusFilter, platform);
      return exportCancelOrderList({
        ...data,
        timeZone: getLocalTimeZone(),
      });
    },
    {
      manual: true,
    },
  );

  const handleExport = useMemoizedFn(() => {
    run(exportList);
  });

  return (
    <Button icon={<DownloadOutlined />} loading={exportLoading} onClick={handleExport}>
      {t('scene.orderWorkspace.cancelOrderTab.action.export')}
    </Button>
  );
};
